import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../js/base';
import bootstrapBreakpoints from '../grid/index';
import { EmptyNodeList } from '../utils/index';
import { offVPort, onVPort, ScreenSize } from '../../utility/breakPointEvents';

class Texts extends BaseObject { }

class ClassList extends BaseObject {
    noScroll = 'overflow-hidden';
    add = 'js--add-noscroll';
}

class Selectors extends BaseObject {
    toggles = '.js--add-noscroll, .js--remove-noscroll'
}

class Elements extends BaseElements<Selectors> {
    toggles: NodeListOf<HTMLElement> = new EmptyNodeList();

    constructor(selectors: Selectors) {
        super(selectors, true);
    }

    initElements() {
        this.initElementsByLoop();
    }

}

interface NoScroll extends BaseService<Selectors, Elements, ClassList, Texts> { }

let $document, $window;

@BaseInjector(Selectors, Elements, ClassList, Texts)
class NoScroll {
    protected get vPort(): ScreenSize {
        return 'sm'
    }

    protected noScrollToggled: boolean;

    constructor() {
        $window = $(window);
    }

    initialize(): void {
        this.elements.initElements();
        this.addEventListeners();
    }

    addEventListeners() {
        this.elements.toggles?.forEach(toggle => {
            toggle?.addEventListener('click', this.onClick.bind(this, toggle));
        });
        this.setViewPortListeners(this.vPort);
    }


    onClick(toggle: HTMLElement) {
        if (bootstrapBreakpoints[this.vPort] < $window.width()) {
            this.noScrollToggled = !this.noScrollToggled;
            return;
        }
        this.toggleNoScroll(toggle);
    }

    toggleNoScroll(toggle: HTMLElement) {
        const { noScroll, add } = this.classList;
        if (toggle.classList.contains(add)) {
            document.body.classList.add(noScroll);
            this.noScrollToggled = true;
        } else {
            document.body.classList.remove(noScroll);
            this.noScrollToggled = false;
        }
    }


    setViewPortListeners(viewPort: ScreenSize) {
        onVPort(viewPort, this.onViewPort.bind(this));
        offVPort(viewPort, this.offViewPort.bind(this));
    }

    onViewPort() {
        if (this.noScrollToggled) {
            document.body.classList.add(this.classList.noScroll);
        }
    }

    offViewPort() {
        document.body.classList.remove(this.classList.noScroll);
    }


}

export default NoScroll;

export {
    Elements as NoScrollElements,
    Selectors as NoScrollSelectors,
    ClassList as NoScrollClassList,
    Texts as NoScrollTexts
}